import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockWhatsInReport');

@I18nHoc(translates())
export default class WhatsInReportBlock extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { className } = this.props;

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'topic')}>
          <Col {...classes('col')} allPr={0}>
            <div {...classes('text', 'h2')}><h2 children={i18n('whatsInReportH2')} /></div>
          </Col>
        </Row>
        <Row {...classes('row', 'block')} mtColumn mpColumn>
          <Col {...classes('col', 'img')} allPr={0}>
            <div {...classes('imgContainer')}>
              <img {...classes('img')} src={i18n('imgPDF3')} alt={i18n('whatsInReportH3')} loading="lazy" decoding="async" />
            </div>
          </Col>
          <Col {...classes('col', 'info')} allPr={0}>
            <div {...classes('text', 'h3')}><h3 children={i18n('whatsInReportH3')} /></div>
            <Trans lang="ru">
              <div {...classes('description', 'separatorLeft')}>
                <p {...classes('text')} children="Мы предоставляем максимум информации о наличии у застройщика документов на строительство и их соответствие требованиям Закона Украины. Отчёт содержит выписки из Государственного реестра вещных прав на все участки, на которых ведётся строительство ЖК. Это платный официальный документ о правопользователях земельных участков, целевом назначении и отягощениях." />
              </div>
              <div {...classes('text', 'h4')}><h4 children="Мы предоставим вам данные таких государственных реестров и баз данных:" /></div>
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="реестр юридических лиц и физических лиц – предпринимателей" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="реестр вещных прав" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="публичная кадастровая карта и геокадастр" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="судебный реестр" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="единый реестр строительной деятельности" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="реестр департамента градостроительства и архитектуры" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="решения государственных органов власти" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="информация о субъектах хозяйствования, которые имеют налоговый долг" />
                  </div>
                </li>
              </ul>
              <div {...classes('description')}>
                <p {...classes('text')} children="Это максимальный перечень государственных реестров, связанных со строительством ЖК, который доступен в Украине. Он отвечает на все вопросы законности строительства." />
              </div>
            </Trans>
            <Trans lang="ua">
              <div {...classes('description', 'separatorLeft')}>
                <p {...classes('text')} children="Ми надаємо максимум інформації про наявність у забудовника документів на будівництво та їх відповідність вимогам Закону України. Звіт містить витяги з Державного реєстру речових прав на всі ділянки, на яких ведеться будівництво ЖК. Це платний офіційний документ про правокористувачів земельних ділянок, цільове призначення та обтяження." />
              </div>
              <div {...classes('text', 'h4')}><h4 children="Ми надамо вам дані таких державних реєстрів та баз даних:" /></div>
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="реєстру юридичних осіб та фізичних осіб – підприємців" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="реєстр речових прав" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="публічна кадастрова карта і геокадастр" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="судовий реєстр" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="єдиний реєстр будівельної діяльності" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="реєстр департаменту містобудування та архітектури" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="рішення державних органів влади" />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="інформація про суб'єктів господарювання, які мають податковий борг" />
                  </div>
                </li>
              </ul>
              <div {...classes('description')}>
                <p {...classes('text')} children="Це максимальний перелік державних реєстрів, пов'язаних із будівництвом ЖК, який доступний в Україні. Він відповідає на всі запитання щодо законності будівництва." />
              </div>
            </Trans>
          </Col>
        </Row>
      </div>
    );
  }
}
